import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { colors } from '@global/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  button: {
    marginRight: theme.spacing(1),
  },
}))

export const stepButtonText = css`
  text-align: left;
  font-weight: bold;
  color: ${colors.blue.smokey_light};
  font-size: 14px;
`

export const fabs = css`
  position: absolute;
  top: 12px;
  right: 24px;
`

export const main = css`
  height: calc(100% - 80px);
  overflow: auto;
  position: relative;
`

export const root = css`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
`

export const circularProgress = css`
  text-align: center;
  margin-top: 100px;
`

export const footer = css`
  min-height: 80px;
  display: flex;
  white-space: nowrap;
  padding: 0 24px 100px;
  background-color: #fff;
`

export const navButtonContainer = css`
  text-align: right;
`

export const popper = css`
  z-index: 1100;
`

export const notifications = css`
  width: 350px;
  height: 350px;
  display: flex;
  flex-direction: column;
  background-color: white;
  overflow: hidden;
`

export const notificationContainer = css`
  max-height: 100%;
  overflow: scroll;
  cursor: pointer;
  padding: 8px;
`

export const notification = css`
  margin-bottom: 4px;
`
